import React from 'react'

/**
 * @param {children}: String, see https://material.io/resources/icons/?style=baseline 
 */
class Icon extends React.Component
{

    render()
    {
        return (
            <i style={ this.props.style } className={ "material-icons dk-icon " + (this.props.className || "") }>
                { this.props.children }
            </i>
        )
    }

}

export { Icon }
export default Icon